// Dependencies
import styled from 'styled-components';

// Images
import quote from '../../../../img/icons/quote.svg';

const BlogPostContentStyles = styled.div`
  .wp-caption {
    width: auto !important;
    max-width: 100%;
  }

  .gatsby-image-wrapper,
  img {
    width: 100%;
    max-height: 31.25rem;
    object-fit: cover;
    object-position: center;
  }

  iframe {
    width: 100%;
    aspect-ratio: 16 / 9;
  }

  blockquote {
    margin: 0 0 1.5rem;
    padding: 2rem;
    font-style: italic;
    background-color: var(--color-sand);

    &::before {
      content: '';
      display: block;
      width: 1.7rem;
      height: 1.7rem;
      margin: 0 0 0.2rem;
      background-image: url(${quote});
    }
  }

  @media (min-width: 768px) {
    blockquote {
      &::before {
        width: 2rem;
        height: 2rem;
      }
    }
  }
`;

export default BlogPostContentStyles;
